import {takeEvery} from "redux-saga/effects";
import {ActionType, getType} from "typesafe-actions";
import {leaveFeedback} from "../actions";
import apiCall from "../../../shared/utils/apiCall";

export function* watchQuestionFeedback() {
    yield takeEvery(getType(leaveFeedback), function* ({payload}: ActionType<typeof leaveFeedback>) {
        yield apiCall({
            params: {
                section: "questions",
                method: "postFeedback",
            },
            data: payload
        })
    });
}